import { Button } from "./ui/button";
import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1628841380003-90e0e39b3ba1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100vh] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/65" />

      <div className="relative z-10 container mx-auto px-6 md:px-12 max-w-7xl flex flex-col justify-end min-h-[100vh] pb-24 pt-32">
        <div className="max-w-3xl fade-up">
          <p className="overline text-[#F2C9A6] mb-6" data-testid="hero-eyebrow">
            Madikeri · Coorg · Karnataka
          </p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white font-medium leading-[1.05] tracking-tight text-balance">
            A spacious family homestay,<br />
            surrounded by the misty hills of Coorg.
          </h1>
          <p className="mt-8 font-sans text-base sm:text-lg text-white/85 max-w-xl leading-relaxed">
            Aroha Homes is a boutique homestay in Madikeri offering 2BHK suites, a
            rooftop glass couple's room and homemade Coorg-style food —
            a slow, restorative escape into the Western Ghats.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Button
              data-testid="hero-cta-book"
              className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-sm tracking-wider uppercase"
              onClick={() => document.getElementById("stays")?.scrollIntoView({ behavior: "smooth" })}
            >
              Explore Stays
            </Button>
            <Button
              data-testid="hero-cta-facilities"
              variant="outline"
              className="rounded-full border-white/70 bg-white/5 text-white hover:bg-white hover:text-foreground px-8 py-6 text-sm tracking-wider uppercase"
              onClick={() => document.getElementById("facilities")?.scrollIntoView({ behavior: "smooth" })}
            >
              Facilities
            </Button>
          </div>
        </div>

        <a
          href="#stays"
          aria-label="Scroll to stays"
          className="absolute bottom-10 right-8 hidden md:inline-flex items-center gap-2 text-white/70 hover:text-white text-xs uppercase tracking-[0.3em]"
          data-testid="hero-scroll-indicator"
        >
          Scroll <ArrowDown size={14} />
        </a>
      </div>
    </section>
  );
}
